import { render, staticRenderFns } from "./Subnets.vue?vue&type=template&id=415abee2&scoped=true&"
import script from "./Subnets.vue?vue&type=script&lang=js&"
export * from "./Subnets.vue?vue&type=script&lang=js&"
import style0 from "./Subnets.vue?vue&type=style&index=0&id=415abee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415abee2",
  null
  
)

export default component.exports